/** @format */

export type ContentEditorSelectedTag = {
  id?: string | number | null;
  label?: string;
  isNew?: boolean;
};

export type ContentEditorNewTag = {
  id: string;
  label: string;
  isNew: true;
};

export function createNewContentEditorTag(rawLabel: string): ContentEditorNewTag | null {
  const label = String(rawLabel || '').trim();
  if (!label) return null;
  return {
    id: `new:${label.toLowerCase()}`,
    label,
    isNew: true
  };
}

export function selectedTagsIncludeLabel(
  tags: ContentEditorSelectedTag[] | null | undefined,
  label: string
): boolean {
  const normalized = String(label || '')
    .trim()
    .toLowerCase();
  if (!normalized) return false;
  return (Array.isArray(tags) ? tags : []).some(
    tag =>
      String(tag?.label || '')
        .trim()
        .toLowerCase() === normalized
  );
}

export function splitSelectedTags(selectedTags: ContentEditorSelectedTag[] | null | undefined): {
  tagIds: Array<string | number>;
  newTags: string[];
} {
  const tagIds: Array<string | number> = [];
  const newTags: string[] = [];

  (Array.isArray(selectedTags) ? selectedTags : []).forEach(tag => {
    if (!tag) return;
    if (tag.isNew) {
      const label = String(tag.label || '').trim();
      if (label) newTags.push(label);
      return;
    }
    if (tag.id != null && tag.id !== '') {
      tagIds.push(tag.id);
    }
  });

  return { tagIds, newTags };
}
